module.exports = {"id":"198760","name":"Saphir Taïder","rating":"75","photo":"./data/images/photos/0/198760.png","club":{"name":"Impact Montréal","logo":"./data/images/clubs/ImpactMontreal.png"},"positions":["MC","MDC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SaphirTaider0.json
// module id = 3833
// module chunks = 0